import { FieldDefinition } from '@stylehaven/components';
import { ApiFragment } from '../../../entities';

export const GetField = (fragment: ApiFragment, field: FieldDefinition | string | null): any | null => {
    if (!field || !fragment) {
        return null;
    }

    if ((field as FieldDefinition).DottedKey) {
        return fragment.getField((field as FieldDefinition).DottedKey);
    } else {
        return fragment.getField(field as string);
    }
};
